module.exports = __webpack_public_path__ + "assets/img/login-home-page1.c6fcbd99.png";